(() => {
 const flotingLabelClass = 'floting-label';
 let flotingLabelElements = document.getElementsByClassName(flotingLabelClass);
 for (var i=0, len=flotingLabelElements.length|0; i<len; i=i+1|0) {
     let flotingLabelElement = flotingLabelElements[i];
     if(flotingLabelElement.children[1].value) flotingLabelElement.classList.add('floting-label--not-empty');
     flotingLabelElement.children[1].oninput = function(e) {
         if(this.value){
             flotingLabelElement.classList.add('floting-label--not-empty');
         }else{
             flotingLabelElement.classList.remove('floting-label--not-empty');
         }
     };
 }
})();